/*
 * Sleep2Care — global adfærd for PDP-afsnit som selvstændige sektioner.
 * Håndterer reveal-animationer, FAQ-accordion og anatomi-hover på tværs af
 * sektioner (dvs. virker uanset hvilken sektion elementerne ligger i).
 * Dækker både s2c-motorens klasser (s2c-*) og v2-motorens (uden prefix).
 * Idempotent: kører kun én gang, og binder via event-delegation + observer.
 */
(function () {
  if (window.__s2cAfsnitInit) return;
  window.__s2cAfsnitInit = true;

  // --- Reveal on scroll ---
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.s2c-reveal:not(.is-in), .reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.14 });
    els.forEach(function (el) { obs.observe(el); });
  }

  // --- FAQ accordion (event-delegation, virker for dynamisk indhold) ---
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.s2c-faq-item__q, .faq-item__q');
    if (!q) return;
    var item = q.parentElement;
    var open = item.classList.contains('is-open');
    // luk søskende i samme liste
    var list = item.parentElement;
    if (list) list.querySelectorAll('.s2c-faq-item.is-open, .faq-item.is-open').forEach(function (i) { i.classList.remove('is-open'); });
    if (!open) item.classList.add('is-open');
  });

  // --- Anatomi-hover (highlight tilsvarende lag) ---
  document.addEventListener('mouseover', function (e) {
    var item = e.target.closest('.s2c-anat-item, .anat-item');
    if (!item) return;
    var hot = item.dataset.hot;
    if (!hot) return;
    var scope = item.closest('.s2c-anatomy, .anatomy') || document;
    scope.querySelectorAll('.s2c-anat-layer, .anat-layer').forEach(function (l) { l.classList.remove('is-hot'); });
    var layer = scope.querySelector('.s2c-anat-layer.' + hot + ', .anat-layer.' + hot);
    if (layer) layer.classList.add('is-hot');
  });

  // --- CTA "scroll til køb-boks" ---
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.s2c-scroll-top, [data-s2c-scroll-buy]');
    if (!btn) return;
    var atc = document.querySelector('[id^="s2c-atc-"], .s2c-pdp__hero, #MainContent');
    if (atc) { e.preventDefault(); atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  });

  function boot() { initReveal(document); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // Re-init reveal når sektioner indlæses i temaeditoren
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
})();
